import React from "react";
import { North, ThemeDefinition } from "@hackthenorth/north";
import themeDef from "theme";

import Router from "./Router";

const App = () => (
  <North themeDefinition={(themeDef as unknown) as ThemeDefinition}>
    <Router />
  </North>
);

export default App;
